import Api from 'utils/ApiRequest'
import API from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_SALES_ORDER_LIST_REQUEST,
  FETCH_SALES_ORDER_LIST_SUCCESS,
  FETCH_SALES_ORDER_LIST_ERROR,
  FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_REQUEST,
  FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_SUCCESS,
  FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_ERROR,
  SAVE_TRACKING_MONITOR_REMOVAL_REQUEST,
  SAVE_TRACKING_MONITOR_REMOVAL_SUCCESS,
  SAVE_TRACKING_MONITOR_REMOVAL_ERROR,
} from 'actionTypes'

export const fetchSalesOrderList = (token, param) => (dispatch) => {
  dispatch(showSpinner())
  dispatch(actionSet(FETCH_SALES_ORDER_LIST_REQUEST))

  return new Api(token, dispatch)
    .post(API.FETCH_SALES_ORDER_LIST, param)
    .then((response) => {
      dispatch(getPages(response.metadata))
      dispatch(actionSet(FETCH_SALES_ORDER_LIST_SUCCESS, response.data))
    })
    .catch((error) => dispatch(actionSet(FETCH_SALES_ORDER_LIST_ERROR, error)))
    .finally(() => dispatch(hideSpinner()))
}

export const fetchRemovalReasonList = (token) => (dispatch) => {
  dispatch(showSpinner())
  dispatch(actionSet(FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_REQUEST))

  return new Api(token, dispatch)
    .get(API.FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST)
    .then((response) =>
      dispatch(
        actionSet(
          FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_SUCCESS,
          response.data
        )
      )
    )
    .catch((error) =>
      dispatch(
        actionSet(FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_ERROR, error)
      )
    )
    .finally(() => dispatch(hideSpinner()))
}

export const remove =
  (token, param, successCallback, errorCallback) => (dispatch) => {
    dispatch(showSpinner())
    dispatch(actionSet(SAVE_TRACKING_MONITOR_REMOVAL_REQUEST))

    return new Api(token, dispatch)
      .post(API.SAVE_TRACKING_MONITOR_REMOVAL, param)
      .then(() => dispatch(actionSet(SAVE_TRACKING_MONITOR_REMOVAL_SUCCESS)))
      .then(() => successCallback())
      .catch((error) => {
        dispatch(actionSet(SAVE_TRACKING_MONITOR_REMOVAL_ERROR, error))

        errorCallback()
      })
      .finally(() => dispatch(hideSpinner()))
  }
